import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBriefcase = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13 26v7c0 1.1.9 2 2 2h18a2 2 0 002-2v-7M29 17v-2a2 2 0 00-2-2h-6a2 2 0 00-2 2v2",
			stroke: "#311B92",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 18h24v6.52a44.93 44.93 0 01-9 1.4v2a46.74 46.74 0 009.66-1.51A1.85 1.85 0 0038 24.6V18a2 2 0 00-2-2H12a2 2 0 00-2 2v6.6c0 .84.53 1.59 1.34 1.81 1.75.48 5.14 1.25 9.66 1.5V26v-.09a44.93 44.93 0 01-9-1.4V18z",
			fill: "#311B92"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#311B92",
			strokeWidth: 2,
			strokeLinejoin: "round",
			d: "M21 25h6v4h-6z"
		})
	]
});
export default SvgBriefcase;
